import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import ArticleCard from "@/components/feature/ArticleCard";
import { categories } from "@/mocks/categories";
import { articles, getFeaturedArticles } from "@/mocks/articles";
import { faqItems } from "@/mocks/faq";

export default function Home() {
  const featuredArticles = getFeaturedArticles(6);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20minimalist%20composition%20with%20warm%20dark%20amber%20and%20deep%20brown%20gradients%2C%20sophisticated%20flowing%20geometric%20shapes%2C%20dramatic%20soft%20lighting%2C%20luxurious%20editorial%20aesthetic%2C%20no%20people%2C%20fine%20art%20style%20with%20rich%20textures%20and%20deep%20shadows&width=1920&height=800&seq=hero-main-01&orientation=landscape"
            alt="女王调教指南 - 专业支配关系指导"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 leading-tight">
              女王调教：专业支配关系指南与技巧
            </h1>
            <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
              深入探讨女王调教的核心理念、技巧与实践方式。为对支配与臣服关系感兴趣的成年人提供专业指导，涵盖基本原则、安全规范、心理层面与实操技巧。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/queen-domination-basics"
                className="px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始学习
              </Link>
              <Link
                to="/about"
                className="px-6 py-2.5 border border-white/30 text-white text-sm font-medium rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="px-4 md:px-6 lg:px-10 py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
              探索内容分类
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-5 text-center transition-all duration-300 hover:border-primary-200/60 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-50 rounded-full group-hover:bg-primary-100 transition-colors">
                    <i className={`${cat.icon} text-xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="px-4 md:px-6 lg:px-10 py-14">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                精选文章
              </h2>
              <Link
                to="/category/queen-domination-basics"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="px-4 md:px-6 lg:px-10 py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                  {articles.length}
                </div>
                <p className="text-sm text-foreground-600">专业文章</p>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-1">
                  {categories.length}
                </div>
                <p className="text-sm text-foreground-600">内容分类</p>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-500 mb-1">
                  50+
                </div>
                <p className="text-sm text-foreground-600">实操技巧</p>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                  100%
                </div>
                <p className="text-sm text-foreground-600">安全为先</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="px-4 md:px-6 lg:px-10 py-14">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
              常见问题
            </h2>
            <div className="flex flex-col gap-3">
              {faqItems.slice(0, 6).map((faq, idx) => (
                <details
                  key={faq.id}
                  className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-900 pr-4">
                      {faq.question}
                    </span>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20minimalist%20composition%20with%20warm%20deep%20amber%20and%20rich%20brown%20gradients%2C%20sophisticated%20flowing%20organic%20shapes%2C%20dramatic%20yet%20soft%20lighting%2C%20luxurious%20editorial%20aesthetic%2C%20no%20people%2C%20fine%20art%20style%20with%20deep%20textures&width=1920&height=600&seq=cta-home-02&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 w-full px-4 text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
              准备好开始您的女王调教旅程了吗？
            </h2>
            <p className="text-sm text-white/70 mb-6 max-w-lg mx-auto">
              浏览我们的分类内容，从入门基础到进阶技巧，找到最适合您的指导。
            </p>
            <Link
              to="/category/queen-domination-basics"
              className="inline-block px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即探索
            </Link>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "女王调教指南",
            "url": window.location.origin,
            "description":
              "深入探讨女王调教的核心理念、技巧与实践方式。为对支配与臣服关系感兴趣的成年人提供专业指导。",
            "potentialAction": {
              "@type": "SearchAction",
              "target": `${window.location.origin}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "女王调教指南",
            "url": window.location.origin,
            "description":
              "专业女王调教关系指导平台，提供支配与臣服关系的教育内容。",
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.slice(0, 6).map((faq) => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}